const pluralize = (singularTxt: string, pluralTxt: string, count: number): string =>
  count === 1 ? singularTxt : pluralTxt;

export default pluralize;
